import { render, staticRenderFns } from "./LockedMessages.vue?vue&type=template&id=44fcceea&scoped=true"
import script from "./LockedMessages.vue?vue&type=script&lang=js"
export * from "./LockedMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fcceea",
  null
  
)

export default component.exports